<app-user-header></app-user-header>

<div class="row h-100">
        <!-- left sidebar -->
        <div class="col-md-2 fixed pl-0 py-2 left left-sidebar">
            <ul class="nav flex-md-column flex-nowrap justify-content-center">
                <li style="text-align: center; margin-top: 34px;"><img style="    border: 1px solid #FFF;border-radius: 49%;width: 40%;height: 40%;"
                        src="assets/images/user-image.png" class="img-circle" alt="Cinque Terre">
                    <h5 class="center user-text" style="text-align:  center;">
                        Ramki</h5>
                </li>

                <!-- <li>

                    <a class="nav-link">
                           <span> Tax Year        </span>           
                            
                                <select style="text-align-last:center;" class="form-control select-lag" name="userYear" id="userYear"
                                    onchange="yearChange()">                                       
                                    <option value="<?php echo $i;?>"></option>                   
                                </select>
                            
                    </a>
                    
                </li> -->

                          
                <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Dashboard">
                    <a class="nav-link" href="<?php echo HTTP_URL; ?>users/dashboard">
                        <img src="assets/images/dashboard.svg" style="width: 24px; height: 20px;">&nbsp;
                        <span class="nav-link-text">Dashboard</span>
                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" href="#">Link</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#">Link</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#">Link</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#">Link</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#">Link</a>
                </li>
            </ul>
        </div>

</div>
        <!-- <footer class="navbar navbar-expand bg-light navbar-light">
                <ul class="navbar-nav">
                    <li class="nav-item"><a href="#" class="nav-link">Footer</a></li>
                    <li class="nav-item"><a href="#" class="nav-link">Link</a></li>
                    <li class="nav-item"><a href="#" class="nav-link">Link</a></li>
                    <li class="nav-item"><a href="#" class="nav-link">More</a></li>
                </ul>
            </footer> -->